module.exports = __webpack_public_path__ + "img/styria-verlag.260f5b4a.svg";